import supabase from '../supabaseClient'

const SESSION_EVENTS = new Set(['INITIAL_SESSION', 'SIGNED_IN', 'TOKEN_REFRESHED'])

/**
 * Resolve once Supabase has finished hydrating auth from storage / URL hash.
 * A bare getSession() on first paint can return null before INITIAL_SESSION fires.
 */
export function waitForAuthSession(timeoutMs = 5000) {
  return new Promise((resolve) => {
    let settled = false
    let timer
    let subscription

    const finish = (session) => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      subscription?.unsubscribe()
      resolve(session ?? null)
    }

    const { data: { subscription: sub } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (SESSION_EVENTS.has(event) && session?.user) {
          finish(session)
          return
        }
        if (event === 'INITIAL_SESSION') {
          finish(session)
        }
      },
    )
    subscription = sub

    timer = setTimeout(() => finish(null), timeoutMs)

    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) finish(session)
    })
  })
}
